import useToken from "../../components/login/useToken";
import differenceInDays from "date-fns/differenceInDays";
import { useEffect, useRef, useState } from "react";
import { EnviaDatosAServicio, EnviaDatosANuevoServicio, FormateaCurrency } from "../../Funciones/Funciones";
import classes from "./EstudianteElimina.module.css";
import { Slide, toast } from "react-toastify";
import { NumericFormat } from "react-number-format";



function EliminaEstudiante(props) {
  //console.log(props)
  const [devolverCalculado, setDevolverCalculado] = useState("");
  const [devolverDesglosado, setDevolverDesglosado] = useState("");
  const [diasDesglosado, setDiasDesglosado] = useState("");
  const Hoy = new Date();
  const [fechaDesocupa, setFechaDesocupa] = useState(
    new Date(Hoy.getFullYear(), Hoy.getMonth(), Hoy.getDate(), 0, 0, 0)
      .toISOString()
      .substring(0, 10)
  );
  const [composturas, setComposturas] = useState(0);
  const DepGar = props.estudiante.Deposito * 1;
  const Precio = props.estudiante.Precio * 1;
  const UltDiaPagado = props.estudiante.UltDiaPagado;
  //const composturasRef = useRef();
  const marcarDevueltoRef = useRef();
  const agregaEgresosRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useToken();
  const idUsu = token.Id;
  const [datos, setdatos] = useState();

  function LlaveDeArray(llaves) {
    var respuesta = "";
    for (var i = 0; i < llaves.length; i++) {
      respuesta = respuesta + llaves[i].Llave + ", ";
    }
    if (respuesta.length > 0) {
      respuesta = respuesta.substring(0, respuesta.length - 2);
    }
    else {
      respuesta = "No Tiene"
    }
    return respuesta;
  }

  function respServ(respuesta) {
    console.log(respuesta)
    setdatos(respuesta);
  }

  useEffect(() => {
    setIsLoading(true);

    const datos = {
      IDEst: props.estudiante.IDEst
    };
    EnviaDatosANuevoServicio(
      "DatosParaEliminarEstudiante",
      datos,
      respServ,
      setIsLoading,
      null,
      idUsu
    );
  }, [props, idUsu])

  const submitHandler = async (ev) => {
    ev.preventDefault();
    const DatosValidos = ValidaDatos();
    const gastoGar =
      (agregaEgresosRef.current.checked ? "SI" : "NO") +
      (marcarDevueltoRef.current.checked ? "SI" : "NO");
    if (DatosValidos === "") {
      const ElimN = {
        IDEst: props.estudiante.IDEst,
        FechaIng: fechaDesocupa.toString().toUpperCase().replace(/-/gi, ""),
        Llaves: props.estudiante.Llaves,
        IDHab: props.estudiante.IDHab,
        Email: gastoGar, //aqui va si se debe guardar el gasto o no como "SI" O "NO" e inmediatamente si se indico marcar como devuelto el deposito en garantía, otra vez, con "SI" o "NO"
        Nombre: props.estudiante.Nombre,
        Estado: devolverCalculado, //aqui va el monto a devolver
        FechaBaja: fechaDesocupa.toString().toUpperCase().replace(/-/gi, ""),
      };
      //console.log("ElimN", ElimN);
      const envio = await EnviaDatosAServicio(ElimN, "EliminaInquilino");
      if (envio.ERROR === "") {
        toast("Inquilino eliminado", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          transition: Slide,
        });
        props.EliminadoOK();
        //props.setMuestraNuevoProv(false);
        //props.setRecargar(true);
        /*
        props.setDialogoOK({
          texto: "Eliminado",
          mostrandoError: false,
          recargar: true,
          cerrarVentana: "mostrarElimina",
        });
        props.setMuestraDialogoOK(true);*/
        //alert("Guardado OK");
        //props.EliminadoOK();
        //agregar nuevo a estudiantes
      } else {
        props.setDialogoOK({
          texto: "Error al guardar: " + envio.DESCERROR,
          mostrandoError: true,
          recargar: false,
          cerrarVentana: "",
        });
        props.setMuestraDialogoOK(true);
        //alert("Error al guardar: " + envio.DESCERROR);
      }
    } else {
      props.setDialogoOK({
        texto: "Revisa los siguientes datos\n" + DatosValidos,
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
      //alert("Revisa los siguientes datos\n" + DatosValidos);
    }
  };

  function ValidaDatos() {
    var respuesta = "";

    return respuesta;
  }

  function cambioFecha(ev) {
    setFechaDesocupa(
      new Date(ev.target.value + " 0:0:0").toISOString().substring(0, 10)
    );
  }

  function CancelaElimina(ev) {
    ev.preventDefault();
    props.setMostrarElimina(false);
  }

  useEffect(() => {
    if (datos !== undefined) {
      console.log(datos, props.estudiante)
      var ultimoDiaPagado = new Date(
        parseInt(datos.ultDiaPagado.slice(0, 4)),
        parseInt(datos.ultDiaPagado.slice(4, 6)) - 1,
        parseInt(datos.ultDiaPagado.slice(6, 8))
      );

      const dias = differenceInDays(
        ultimoDiaPagado,
        new Date(fechaDesocupa + " 0:0:0")
      );
      const montoExtra = (parseFloat(datos.ultimoMonto) / 30) * dias;
      var comp = composturas;
      if (composturas === undefined)
        comp = 0
      setDevolverCalculado(parseFloat(datos.deposito) + parseFloat(montoExtra) - parseFloat(comp));
      
      var agregar = " a agregar"
      var signo = " + "
      if (dias < 0) {
        agregar = " a quitar"
        signo = " - "
      }
      setDevolverDesglosado(FormateaCurrency.format(datos.deposito) + signo + FormateaCurrency.format(Math.abs(montoExtra)) + " - " + FormateaCurrency.format(comp))
      setDiasDesglosado(Math.abs(dias) + " días a " + FormateaCurrency.format((parseFloat(datos.ultimoMonto) / 30)) + " = " + FormateaCurrency.format(Math.abs(parseFloat(montoExtra))) + agregar);
      console.log("ME", montoExtra, (datos.deposito + montoExtra - comp))
    }
  }, [datos, UltDiaPagado, DepGar, fechaDesocupa, Precio, composturas, props.estudiante]);

  //console.log(props);
  /*console.log(
    "UE",
    UltDiaPagado,
    Precio,
    DepGar,
    composturas,
    devolverCalculado
  );*/

  /********************************************************************************/
  /*************************** RENDER *********************************************/
  /********************************************************************************/

  if (isLoading) {
    return (
      <section>
        <h1>Cargando datos...</h1>
        <h1>
          <i className="fas fa-spinner fa-spin"></i>
        </h1>
      </section>
    );
  }
  return (
    <section className={classes.modal}>
      <div className={classes.contBotTop}>
        {props.nivel === 1 && (
          <button className={classes.botTop} onClick={submitHandler}>
            <i className="fas fa-trash-alt"></i>
          </button>
        )}
        <button onClick={CancelaElimina}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <h1 className={classes.h1loc}>Baja de Estudiante</h1>
      <form>
        <div>
          <label className={classes.labelP}>Nombre</label>
          <input
            readOnly
            type="text"
            value={props.estudiante.Nombre}
            className={classes.textareaNE}
          ></input>
        </div>
        <div>
          <label className={classes.labelP}>Habitación</label>
          <input
            readOnly
            type="text"
            value={props.estudiante.Habitacion}
            className={classes.textareaNE}
          ></input>
        </div>
        {/*<div>
          <label className={classes.labelP}>Renta</label>
          <NumericFormat
            maxLength="8"
            readOnly
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            defaultValue={props.estudiante.Precio}
            value={props.estudiante.Precio}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          ></NumericFormat>
        </div>*/}
        <div>
          <label className={classes.labelP}>Dep. Garantía</label>
          <NumericFormat
            maxLength="8"
            readOnly
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            //defaultValue={datos.deposito}
            value={datos === undefined ? 0 : datos.deposito}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          ></NumericFormat>
        </div>
        <div>
          <label className={classes.labelP}>Ult. Periodo</label>
          <input
            readOnly
            type="text"
            value={datos.periodo}
            className={classes.textareaNE}
          ></input>
        </div>
        <div>
          <label className={classes.labelP}>Ult. Pago</label>
          <NumericFormat
            maxLength="8"
            readOnly
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            //defaultValue={datos.deposito}
            value={datos.ultimoMonto}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          ></NumericFormat>
        </div>
        <div>
          <label className={classes.labelP}>Monto diario:</label>
          <NumericFormat
            maxLength="8"
            readOnly
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            //defaultValue={datos.deposito}
            value={(datos.ultimoMonto / 30)}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          ></NumericFormat>
        </div>
        <div>
          <label className={classes.labelP}>Llave(s)</label>
          <input
            readOnly
            type="text"
            value={
              props.estudiante.Llaves === null
                ? ""
                : LlaveDeArray(datos.llaves)
            }
            className={classes.textareaNE}
          ></input>
        </div>
        <div>
          <label className={classes.labelP}>Fecha Desocupa</label>
          <input
            required
            type="date"
            defaultValue={fechaDesocupa}
            className={classes.textareaNE}
            onChange={cambioFecha}
          ></input>
        </div>
        <div>
          <label className={classes.labelP}></label>
          <input
            readOnly
            type="text"
            value={
              diasDesglosado}
            className={classes.textareaNE}
          ></input>
        </div>
        <div>
          <label className={classes.labelP}>Composturas</label>
          <NumericFormat
            maxLength="8"
            autoComplete="off"
            id="composturas"
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            defaultValue={composturas}
            value={composturas}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            onValueChange={(values) => {
              setComposturas(values.floatValue);
            }}
          ></NumericFormat>
          {/*<input
            type="text"
            defaultValue={composturas}
            ref={composturasRef}
            onPaste={validaCurrency}
            onKeyPress={validaCurrency}
            onChange={cambioCompostura}
            className={classes.textareaNE}
          ></input>*/}
        </div>
        <div>
          <label className={classes.labelP}>Devolver</label>
          <NumericFormat
            readOnly
            maxLength="8"
            type="text"
            className={classes.textareaNE}
            placeholder="$0.00"
            defaultValue={devolverCalculado}
            value={devolverCalculado}
            prefix={"$"}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          ></NumericFormat>
        </div>
        <div>
          <label className={classes.labelP}></label>
          <input
            readOnly
            type="text"
            value={
              devolverDesglosado}
            className={classes.textareaNE}
          ></input>
        </div>
        <div>
          <input
            type="checkbox"
            id="AgregaEgresos"
            ref={agregaEgresosRef}
            defaultChecked="true"
          ></input>
          <label htmlFor="AgregaEgresos" className={classes.labelCh}>
            Agregar a egresos
          </label>
        </div>
        <div>
          <input
            type="checkbox"
            id="MarcarDevuelto"
            ref={marcarDevueltoRef}
            defaultChecked="true"
          ></input>
          <label htmlFor="MarcarDevuelto" className={classes.labelCh}>
            Marcar Dep en garantía devuelto
          </label>
        </div>
      </form>
    </section>
  );
}

export default EliminaEstudiante;
